import { API_URL } from '../../../app-config/constants';
import { CreateInAppFeedbackRequest, InAppFeedbackDto } from '../../../types/InAppFeedbackDto';
import { get, post } from '../request';

const ENTRY = `${API_URL}/in-app-feedback`;

export function getInAppFeedback(featureName: string): Promise<InAppFeedbackDto> {
    return get(`${ENTRY}/${featureName}`);
}

export function createInAppFeedback(payload: CreateInAppFeedbackRequest): Promise<CreateInAppFeedbackRequest> {
    return post(`${ENTRY}`, { postData: payload });
}
